export default "__VITE_ASSET__Da5C5d1M__"